
import { throwError as observableThrowError, Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { ServiceBase } from '@app/services/base.service';
import { ProcessoMovimentacao, TipoMovimentacao } from '@app/models/processo-movimentacao';
import { HttpClient } from '@angular/common/http';
import { PublicacaoManual } from '@app/pages/processos/importacao-publicacao/publicacao.model';
import { BuscarProcessosComponent } from '@app/pages/processos/buscar-processos/buscar-processos.component';
import { BuscarProcessosModel } from '@app/pages/processos/buscar-processos/model';

@Injectable()
export class ImportacaoPublicacaoService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  enviarPublicacaoXml(formData: FormData): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'processos/importacaoPublicacao/xml', formData, { headers: { meta: ['upload'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  enviarPublicacaoExcel(formData: FormData): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'processos/importacaoPublicacao/excel', formData, { headers: { meta: ['upload'] } }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  enviarPublicacaoManual(publicacaoManual: PublicacaoManual) {
    return this.http
      .post<any>(this.URL_API + 'processos/importacaoPublicacao/PublicacaoManual', publicacaoManual).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  obterPublicacoes(areaId: number, id: number): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/importacaoPublicacao/trazerPublicacoes`, { AreaId: areaId, id: id }).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  // trazerQuantidadePublicacao() {
  //   return this.http.post(this.URL_API + "processos/importacaoPublicacao/trazerQuantidadePublicacao")
  //     .map((res: Response) => res.json())
  //     .catch((error: any) => Observable.throw(error.json()));
  // }

  vincularProcesso(publicacaoId: number, processoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/importacaoPublicacao/vincularProcesso/?publicacaoId=${publicacaoId}&processoId=${processoId}`)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }
  removerPublicacao(publicacaoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/importacaoPublicacao/removerPublicacao/?publicacaoId=${publicacaoId}`)
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  gerarPdf(publicacaoId: number, processoId: number, movimentacaoId: number): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `geradorDePdf/?idPublicacaoId=${publicacaoId}
                                              &processoId=${processoId}
                                              &movimentacaoId=${movimentacaoId}`).pipe(
        map(
          (res) => new Blob([res], { type: 'application/pdf' })
        )
      );
  }
  // `&movimentacaoId=${movimentacaoId}`, { responseType: ResponseContentType.Blob })

  adicionarMovimentacao(processo: ProcessoMovimentacao): Observable<any> {
    return this.http
      .post<any>(this.URL_API + 'processos/importacaoPublicacao/movimentacao/adicionar', processo).pipe(
        catchError((error: any) => observableThrowError(error)));
  }

  movimentacaoEnviarArquivo(processoId: number, movimentacaoId: number, formData: FormData): Observable<any> {
    return this.http
      .post(this.URL_API + `processos/importacaoPublicacao/movimentacao/EnviarArquivo?id=${processoId}&movid=${movimentacaoId}`, formData, { headers: { meta: ['upload'] } })
      .pipe(
        catchError((error: any) => observableThrowError(error))
      );
  }

  obterMovimentacaoPorProcesso(tipoMovimentacao: TipoMovimentacao, id: number, quantidade: number = 0): Observable<any> {
    return this.http
      .get<any>(this.URL_API + `processos/importacaoPublicacao/movimentacao/obter/${tipoMovimentacao}/${id}/${quantidade}`, { headers: { meta: ['search'] } });
  }

  buscaProcesso(buscarProcessosModel: BuscarProcessosModel): Observable<any> {
    return this.http
      .post<any>(this.URL_API + `processos/importacaoPublicacao/processo/buscar/`, buscarProcessosModel);
  }

  //  buscarProcesso(buscarProcessoModel : BuscarProcessosComponent): Observable<any> {
  //     return this.http.post<any>(this.URL_API + `processos/importacaoPublicacao/processo/buscar/`, buscarProcessoModel);
  //   }

}
